import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-quality-checklist',
    templateUrl: './quality-checklist.component.html',
    styleUrls: ['./quality-checklist.component.scss'],
    standalone: false
})
export class QualityChecklistComponent {
  @Input() filledQualities;

  getChecked(title: string): string {
    if (this.filledQualities && this.filledQualities.length > 0) {
      return this.filledQualities.findIndex(value => value === title) > -1 ? 'checked' : '';
    } else {
      return '';
    }
  }
}
